import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_input = _resolveComponent("n-input")!
  const _component_TrashAlt = _resolveComponent("TrashAlt")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_input_group = _resolveComponent("n-input-group")!

  return (_openBlock(), _createBlock(_component_n_input_group, null, {
    default: _withCtx(() => [
      _createVNode(_component_n_input, {
        value: _ctx.content,
        "onUpdate:value": _ctx.onContentChange
      }, null, 8, ["value", "onUpdate:value"]),
      _createVNode(_component_n_button, {
        ghost: "",
        type: "error",
        onClick: _ctx.onDeletePressed,
        disabled: _ctx.disabled
      }, {
        default: _withCtx(() => [
          _createVNode(_component_n_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_TrashAlt)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    _: 1
  }))
}